import { getEnvVar } from 'utils/env';



/**
 * Extract the main API origin for the application from the env.
 *
 * @type {string}
 */
export const API_BASE = getEnvVar('MNL_JAPI_URL', ESIG.thr.baseUrl);


/**
 * The main API origin for the application.
 *
 * @type {string}
 */
export const API_ORIGIN = API_BASE || (window && window.location && window.location.origin);
